/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getRideList: (params) => {
    return axios.get(API_ENDPOINTS.GET_RIDES_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  getRideWaypointList: (params) => {
    return axios.get(API_ENDPOINTS.GET_RIDE_WAYPOINT_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  createRideWaypoint: (data) => {
    return axios.post(API_ENDPOINTS.GET_RIDE_WAYPOINT_LIST, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getRideWaypointById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_RIDE_WAYPOINT_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  updateRideWaypoint: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.GET_RIDE_WAYPOINT_LIST}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteRideWaypoint: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_RIDE_WAYPOINT_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  createRide: (data) => {
    return axios.post(API_ENDPOINTS.GET_RIDES_LIST, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getRideById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_RIDES_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  updateRide: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.GET_RIDES_LIST}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteRide: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_RIDES_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
